import React from 'react'

const IconGoogleMeet = ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style} viewBox="0 0 36 36">
      <path d="M13 7H20V18H8V12A5 5 0 0 1 13 7Z" fill="#00ac47"/>
      <path d="M20 7H28A5 5 0 0 1 33 12V18H20Z" fill="#2684fc"/>
      <path d="M8 18H20V29H13A5 5 0 0 1 8 24Z" fill="#ffba00"/>
      <path d="M20 18H33V24A5 5 0 0 1 28 29H20Z" fill="#ea4335"/>
      <path d="M8 13L2 9V27L8 23Z" fill="#00832d"/>
   </svg>
  )
}
export default IconGoogleMeet
